import axios from "axios";
import qs from "qs";

import utils from "../utils/actionHelpers";

export default {
  getInitialData(context) {
    axios
      .get(`${process.env.VUE_APP_API_INITIAL}`)
      .then(response => {
        context.commit(`setInitialData`, response.data);
        if (context.state.initialData.currents.length > 0) {
          context.dispatch(`mergeCurrents`);
          context.dispatch(`getUserData`);
          // context.commit(`getYogaStyles`, context.getters);
        }
      })
      .catch(e => {
        context.commit(`isNotLoggedIn`);
        context.commit(`addError`, e);
      });
  },

  getUserData(context) {
    const output = {};
    axios
      .get(`${process.env.VUE_APP_API_USER}`)
      .then(response => {
        if (response.data.loggedin === 1) {
          output.isLoggedIn = 1;
          output.level = response.data.sub.level;
          output.nextPayment = utils.formatDate(
            response.data.sub.sub_next_payment
          );
          output.name = response.data.profile.fullname;
          output.subType = response.data.sub.sub_type;
          output.hasToken = utils.hasToken(response.data.sub.token);
          output.email = response.data.profile.email;
          output.myVideos = utils.getMyVideos(response.data.sub.my_videos);
          output.mySeries = utils.getMyVideos(response.data.sub.my_series);
          output.seriesHistory = utils.getSeriesHistory(
            response.data.sub.series_history
          );
          output.history = utils.getHistory(response.data.sub.history);
          output.myTeachers = response.data.sub.my_teachers;
          output.accountStatus = utils.getAccountStatus(
            response.data.sub.account_status
          );
          output.emailConfig = utils.getConfig(response.data.sub.email_config);
          output.remindersConfig = utils.getConfig(
            response.data.sub.reminders_config
          );
          output.xpConfig = utils.getConfig(response.data.sub.xp_config);
          output.interestConfig = utils.getConfig(
            response.data.sub.interests_config
          );
          output.currentConfig = utils.getConfig(
            response.data.sub.current_config
          );
          output.durationConfig = utils.getConfig(
            response.data.sub.duration_config
          );
          output.tempoConfig = utils.getConfig(response.data.sub.tempo_config);
          output.playlists = response.data.sub.playlists;
          output.myViews = response.data.sub.myViews;
          output.totalViews = response.data.sub.totalViews;
          context.commit(`setUserData`, output);
        } else {
          context.commit(`isNotLoggedIn`);
        }
      })
      .catch(e => {
        context.commit(`isNotLoggedIn`);
        context.commit(`addError`, e);
      });
  },

  mergeCurrents(context) {
    const list = [];
    context.state.initialData.currents.forEach(item => {
      const obj = Object.assign(item);
      const resrce = context.state.initialData.currentsResources.filter(
        resource => {
          if (resource.label === item.label) {
            return true;
          }
          return false;
        }
      );
      obj.resource = resrce[0];
      list.push(obj);
    });

    context.commit(`mergeCr`, list);
    // context.commit(`createCurrentConfig`, list);
    // context.commit(`createStyleConfig`, context.state.initialData.styles);
  },
  getVideoList(context) {
    axios
      .get(`${process.env.VUE_APP_API_VIDEOLIST}`)
      .then(response => {
        context.commit(`setVideoList`, response.data);
        context.dispatch(`setSeriesVideoList`);
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  getGvList(context) {
    axios
      .get(`${process.env.VUE_APP_API_SERIESLIST}`)
      .then(response => {
        context.commit(`setGvList`, response.data);
        context.dispatch(`setSeriesVideoList`);
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  setSeriesVideoList(context) {
    if (context.state.series.length > 1 && context.state.videos.length > 1) {
      context.commit(`setSeriesVideoList`);
    }
  },

  selectOption(context, option) {
    context.commit(`setOption`, option);
  },
  selectSingleOption(context, option) {
    context.commit(`setSingleOption`, option);
  },
  addToLikes(context, video) {
    const favs = context.state.user.myVideos.filter(item => {
      if (`${item}` === `${video.id}`) {
        return true;
      }
      return false;
    });
    if (favs.length === 0) {
      axios
        .post(
          `${process.env.VUE_APP_API_POST_ADDTOLIKES}`,
          qs.stringify({
            add: `${video.id}`,
          })
        )
        .then(res => {
          if (res.data.response === `saved`) {
            context.commit(`addToLikes`, video);
            context.commit(`flashMessage`, `הוסף למועדפים`);
          }
        })
        .catch(e => {
          context.commit(`addError`, e);
        });
    } else {
      axios
        .post(
          `${process.env.VUE_APP_API_POST_ADDTOLIKES}`,
          qs.stringify({
            remove: `${video.id}`,
          })
        )
        .then(() => {
          context.commit(`removeFromLikes`, video);
          context.commit(`flashMessage`, `הוסר מהמועדפים`);
        })
        .catch(e => {
          context.commit(`addError`, e);
        });
    }
  },

  addRemoveSeries(context, series) {
    const favs = context.state.user.mySeries.filter(item => {
      if (`${item}` === `${series.id}`) {
        return true;
      }
      return false;
    });
    if (favs.length === 0) {
      axios
        .post(
          `${process.env.VUE_APP_API_POST_ADDSERIES}`,
          qs.stringify({
            add: `${series.id}`,
          })
        )
        .then(res => {
          if (res.data.response === `saved`) {
            context.commit(`addSeries`, series);
            context.commit(`flashMessage`, `הוסף למועדפים`);
          }
        })
        .catch(e => {
          context.commit(`addError`, e);
        });
    } else {
      axios
        .post(
          `${process.env.VUE_APP_API_POST_ADDSERIES}`,
          qs.stringify({
            remove: `${series.id}`,
          })
        )
        .then(() => {
          context.commit(`removeSeries`, series);
          context.commit(`flashMessage`, `הוסר מהמועדפים`);
        })
        .catch(e => {
          context.commit(`addError`, e);
        });
    }
  },

  addRemoveTeacher(context, teacher) {
    return new Promise((resolve, reject) => {
      try {
        const favs = context.getters.likedTeachersArray.filter(item => {
          if (item.id === teacher.id) {
            return true;
          }
          return false;
        });
        if (favs !== null && favs.length === 0) {
          axios
            .post(
              `${process.env.VUE_APP_API_POST_ADDTEACHER}`,
              qs.stringify({
                add: `${teacher.id}`,
              })
            )
            .then(res => {
              if (res.data.response === `saved`) {
                context.commit(`addTeacher`, teacher);
                context.commit(
                  `flashMessage`,
                  `${teacher.name} הוסף לרשימת המורים שלך`
                );
              }
            })
            .catch(e => {
              context.commit(`addError`, e);
            });
        } else {
          axios
            .post(
              `${process.env.VUE_APP_API_POST_ADDTEACHER}`,
              qs.stringify({
                remove: `${teacher.id}`,
              })
            )
            .then(() => {
              context.commit(`removeTeacher`, teacher);
              context.commit(
                `flashMessage`,
                `${teacher.name} הוסר מרשימת המורים שלך`
              );
            })
            .catch(e => {
              context.commit(`addError`, e);
            });
        }

        resolve();
      } catch (e) {
        reject(e);
      }
    });
  },

  sortOptionSelected(context, option) {
    context.commit(`sortSelectOption`, option);
  },

  toggleSelection(context, category) {
    context.commit(`toggleSelection`, category);
  },
  resetSelection(context, category) {
    context.commit(`resetSelection`, category);
  },

  sortGetVideos(context) {
    context.commit(`showHideSpinner`, true);
    context.commit(`cleanResults`);
    axios
      .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
        params: context.getters.optionQueryObj,
      })
      .then(res => {
        context.commit(`showHideSpinner`, false);
        if (res.data.length > 0) {
          context.commit(`sortSetResults`, res.data);
        } else {
          context.commit(`showNoResults`, true);
        }
      })
      .catch(error => {
        context.commit(`addError`, error);
      });
  },

  sortGetResults(context, results) {
    context.commit(`cleanResults`);
    context.commit(`sortSetResults`, results);
  },

  getVideoResults(context, payload) {
    context.commit(`showHideSpinner`, true);
    context.commit(`cleanResults`);
    context.commit(`showNoResults`, false);
    axios
      .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
        params: payload,
      })
      .then(res => {
        context.commit(`showHideSpinner`, false);
        if (res.data.length > 0) {
          let series = [];
          const ids = res.data.map(item => item.id);
          context.state.series.forEach(s => {
            if (s.parent === "672") {
              const videos = s.videoItems.split("||");
              videos.every(v => {
                if (ids.indexOf(parseInt(v, 10)) > -1) {
                  const full = res.data.filter(
                    vid => vid.id === parseInt(v, 10)
                  )[0];
                  series.push({
                    id: s.id,
                    pagetitle: s.pagetitle,
                    image: full.ch,
                    current: full.current,
                    teacher: full.videoTeacher,
                    description: s.description,
                    level: full.videoLvl,
                    videoRating: full.videoRating,
                    videoDuration: full.videoDuration,
                    publishedon: full.publishedon,
                    type: "series",
                  });
                  return false;
                }
              });
            }
          });

          context.commit(`sortSetResults`, [...res.data, ...series]);
        } else {
          context.commit(`showNoResults`, true);
        }
      })
      .catch(error => {
        context.commit(`addError`, error);
      });
  },

  addPage(context) {
    context.commit("addPage");
  },

  setSortBy(context, option) {
    context.commit("setSortBy", option);
  },

  setSearchParams(context, payload) {
    context.commit(`setSearchParams`, payload);
  },

  removeSearchParam(context, payload) {
    context.commit("removeSearchParam", payload);
  },

  updateSearchTerm(context, term) {
    context.commit(`setSearchTerm`, term);
  },

  resetSearchTerm(context) {
    context.commit(`setSearchTerm`, ``);
  },

  addToSeriesHistory(context, obj) {
    if (obj.sid) {
      context.commit(`addToSeriesHistory`, obj);
      const payload = JSON.stringify(context.state.user.seriesHistory);
      axios
        .post(
          `${process.env.VUE_APP_API_POST_SERIESHISTORY}`,
          qs.stringify({
            seriesHistory: payload,
          })
        )
        .then(res => {
          if (res.data.response === `saved`) {
            context.commit(`flashMessage`, `השינויים נשמרו`);
          }
        })
        .catch(e => {
          context.commit(`addError`, e);
        });
    }
  },

  clearResults(context) {
    context.commit(`cleanResults`);
    const options = Object.values(context.state.sort.selected);

    options.forEach(opt => {
      context.commit(`resetSelection`, opt.category);
    });
  },

  setConfig(context, specific) {
    let confKeys = [];
    if (!specific) {
      confKeys = [
        `xpConfig`,
        `interestConfig`,
        `currentConfig`,
        `durationConfig`,
        `tempoConfig`,
      ];
    } else {
      confKeys = [`${specific}`];
    }

    const payload = {};
    confKeys.forEach(conf => {
      const config = context.state.user[conf];
      const selected = [];
      config.forEach(obj => {
        selected.push(obj.selected);
      });
      payload[conf] = `${selected.join(`,`)}`;
    });

    axios
      .post(`${process.env.VUE_APP_API_POST_SETCONFIG}`, qs.stringify(payload))
      .then(res => {
        if (res.data.response === `saved`) {
          context.commit(`flashMessage`, `השינויים נשמרו`);
        }
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  updateProfile(context, data) {
    axios
      .post(`${process.env.VUE_APP_API_POST_UPDATEPROFILE}`, qs.stringify(data))
      .then(res => {
        if (res.data.response === `saved`) {
          context.commit(`flashMessage`, `השינויים נשמרו`);
          context.commit(`changeName`, data.fullname);
        }
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  saveHistory(context) {
    axios
      .post(
        `${process.env.VUE_APP_API_POST_SAVEHISTORY}`,
        qs.stringify({
          hist: context.state.user.history.join(`,`),
        })
      )
      .then(res => {
        if (res.data.response !== `saved`) {
          context.commit(`addError`, `Could not save history`);
        }
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  saveExtendedHistory(context, videoId) {
    axios
      .post(
        `${process.env.VUE_APP_API_EXTENDED_HISTORY}`,
        qs.stringify({
          video_id: videoId,
        })
      )
      .then(res => {
        if (res.data.response !== 1) {
          context.commit(`addError`, `Could not save history`);
        }
      })
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  addToHistory(context, vid) {
    const hist = context.state.user.history;
    if (hist.length > 750) {
      hist.splice(740);
    }

    if (hist.indexOf(vid) === 0) {
      return;
    }

    if (hist.indexOf(vid) > 0) {
      context.commit(`histBringToFront`, vid);
      context.dispatch(`saveHistory`);
    } else {
      context.commit(`addToHistory`, vid);
      context.dispatch(`saveHistory`);
    }
  },

  addToBeginnerList(context) {
    axios
      .post(
        `${process.env.VUE_APP_API_POST_SETCONFIG}`,
        qs.stringify({
          beginner: 1,
        })
      )
      .catch(e => {
        context.commit(`addError`, e);
      });
  },

  changeAccountType(context, type) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.VUE_APP_API_POST_SETCONFIG}`,
          qs.stringify({
            type,
          })
        )
        .then(res => {
          if (res.data.response === `saved`) {
            context.commit(`setAccountType`, type);
            resolve(res.data.price);
          }
        })
        .catch(e => {
          context.commit(`addError`, e);
          reject();
        });
    });
  },

  sendTeacherFeedback(context, data) {
    context.commit(`setFeedbackSending`);
    axios
      .post(`${process.env.VUE_APP_API_POST_FEEDBACK}`, qs.stringify(data))
      .then(res => {
        if (res.data.success === 1) {
          context.commit(`setFeedbackSent`);
        } else {
          context.commit(`setFeedbackError`);
        }
      })
      .catch(e => {
        context.commit(`addError`, e);
        context.commit(`setFeedbackError`);
      });
  },

  resetTeacherFeedback(context) {
    context.commit(`setFeedbackReset`);
  },

  selectPlaylist(context, playlistId) {
    context.commit("setPlaylistSelected", playlistId);
    if (playlistId !== "0") {
      const pl = context.state.user.playlists.find(p => p.id === playlistId);
      const playlist = {
        id: pl.id,
        title: pl.title,
        videos: pl.videos.split(","),
        series: pl.series.split(","),
        collections: pl.collections.split(","),
      };
      context.commit("updatePlaylist", playlist);
    } else {
      const emptyPl = {
        id: "0",
        title: "",
        videos: [],
        series: [],
        collections: [],
      };
      context.commit("updatePlaylist", emptyPl);
    }
  },
  addToPlaylist(context, payload) {
    const itemToAdd = payload.allItems.find(
      item => `${item.id}` === `${payload.toAdd}`
    );
    if (!itemToAdd.type) {
      //video
      if (
        context.state.user.currentPlaylist.videos.includes(`${payload.toAdd}`)
      ) {
        context.commit("removeFromPlaylist", {
          category: "videos",
          toRemove: `${payload.toAdd}`,
        });
      } else {
        context.commit("addToPlaylist", {
          category: "videos",
          toAdd: `${payload.toAdd}`,
        });
      }
    } else {
      if (itemToAdd.parent === "10") {
        //collection
        if (
          context.state.user.currentPlaylist.collections.includes(
            `${payload.toAdd}`
          )
        ) {
          context.commit("removeFromPlaylist", {
            category: "collections",
            toRemove: `${payload.toAdd}`,
          });
        } else {
          context.commit("addToPlaylist", {
            category: "collections",
            toAdd: `${payload.toAdd}`,
          });
        }
      } else {
        //series
        if (
          context.state.user.currentPlaylist.series.includes(`${payload.toAdd}`)
        ) {
          context.commit("removeFromPlaylist", {
            category: "series",
            toRemove: `${payload.toAdd}`,
          });
        } else {
          context.commit("addToPlaylist", {
            category: "series",
            toAdd: `${payload.toAdd}`,
          });
        }
      }
    }
  },
  savePlaylist(context, payload) {
    const params = {
      playlistName: payload.title,
      videos: payload.videos,
      series: payload.series,
      collections: payload.collections,
    };
    if (payload.playlistId) {
      params.playlistId = payload.playlistId;
    }
    return axios
      .post(`${process.env.VUE_APP_API_SAVE_PLAYLIST}`, qs.stringify(params))
      .then(res => {
        if (res.data.success === 1) {
          context.dispatch("getUserData");
        }
        return res.data;
      })
      .catch(e => {
        context.commit(`addError`, e);
        context.commit(`setFeedbackError`);
      });
  },
};
